function getSearchURLParams(url)
{
    if(typeof url !== "string") {
        return {};
    }
   var urlSplit = url.split("?");
   if(urlSplit.length < 2) {
       return {};
   }
   return _.object(_.map(urlSplit[1].split("&"), function(params) {
       return params.split("=");
   }));
}
var jQuery = require("jQuery");
function getSuitelet(script, deploy) {
   return {"customscript_ns_sc_ext_sl_newsletter_sp:customdeploy_ns_sc_ext_sl_newsletter_sp":"/app/site/hosting/scriptlet.nl?script=457&deploy=1&compid=12305959&ns-at=AAEJ7tMQ7e54_MgJiGMOvmZjKFPlxYJUlZVbQlb7C8mDJZKQ-io","customscript_ns_sc_sl_contact_us_form:customdeploy_ns_sc_sl_contact_us_form":"/app/site/hosting/scriptlet.nl?script=453&deploy=1&compid=12305959&ns-at=AAEJ7tMQOBjHOpI4xJuHeMMLdZMC94t3HzhQEmQoiX41rP8iur4","customscript_ns_sc_sl_id_isb:customdeploy_ns_sc_sl_id_isb":"/app/site/hosting/scriptlet.nl?script=451&deploy=1&compid=12305959&ns-at=AAEJ7tMQORLVCGIDFiqT1qtw800i2T2LNJHxVc2oSY5sQ_2dzgM","customscript_ns_sc_sl_inventory_display:customdeploy_ns_sc_sl_inventory_display":"/app/site/hosting/scriptlet.nl?script=452&deploy=1&compid=12305959&ns-at=AAEJ7tMQn--LytQAcrM6K9j2Nl6mA2lRvmrWpj6RCgxNQWRlt9w"}[script + ":" + deploy];
}
var xhrFactory = jQuery.ajaxSettings.xhr;
jQuery.ajaxSettings.xhr = function() {
   var xhr = xhrFactory.apply(this, arguments);
   var open = xhr.open;
   xhr.open = function () {
        var url = arguments[1];
        var assocParams = getSearchURLParams(url);
        if(assocParams.hasOwnProperty("script") && assocParams.hasOwnProperty("deploy")) {
            var hashed = getSuitelet(assocParams["script"], assocParams["deploy"]);
            if(hashed) {
                var hashedParams = getSearchURLParams(hashed);
                var keys = Object.keys(assocParams);
                for (var i=0; i<keys.length; i++) {
                    var key = keys[i];
                    var value = assocParams[key];
                    if(!hashedParams.hasOwnProperty(key))
                    {
                        hashed += "&" + key + "=" + value;
                    }
                }
                arguments[1] = hashed;
            }
        }
        return open.apply(this, arguments);
    }
    return xhr;
}